/**
 * One player's input for one tick. Produced by keyboard/gamepad adapters, AI or the
 * network layer; the sim never sees raw keys.
 */
export interface ControlState {
	thrust: boolean;
	left: boolean;
	right: boolean;
	fireLaser: boolean;
	fireMissile: boolean;
}

export const NO_CONTROLS: Readonly<ControlState> = Object.freeze({
	thrust: false,
	left: false,
	right: false,
	fireLaser: false,
	fireMissile: false,
});
